import { Card } from "ebs-design";

export const BorderedCard = ({ children }: React.PropsWithChildren<{}>) => (
  <Card className="bordered">
    <Card.Body>{children}</Card.Body>
  </Card>
);
